'use strict';

var react = require('react');

function forwardRefWithHook(render) {
  const ForwardedComponent = react.forwardRef(
    render
  );
  ForwardedComponent.useForwardedRef = () => react.useRef(null);
  return ForwardedComponent;
}

module.exports = forwardRefWithHook;
//# sourceMappingURL=index.cjs.map
